/* eslint-disable arrow-body-style */
import $ from 'jquery';

// eslint-disable-next-line no-undef
YP.ExhibitAppManager = () => {
    return {
        /**
         * Launches the Yurplan Exhibit App using a token from the URL parameters.
         * If the app is not installed, it falls back to a web URL.
         *
         * This function detects the user's device type (Android or iOS)
         * and attempts to open the app using a custom URL scheme.
         * If the app is not installed, it redirects to a fallback URL after a short delay.
         *
         * @note This function was inspired by this github : https://gist.github.com/Sarthak30/eeab1c9060a0944180fa663410de8c2f
         */
        launchExhibitApp: () => {
            const urlParams = new URLSearchParams(window.location.search);
            const token = urlParams.get('token');
            const isiOs = navigator.userAgent.match(/(iPad|iPhone|iPod)/i);
            const isAndroid = navigator.userAgent.match(/Android/i);
            const appScheme = token === null
                ? `com.yurplan.${isiOs ? 'YurPlan-Pro---Exposant' : 'exp'}://login`
                : `com.yurplan.${isiOs ? 'YurPlan-Pro---Exposant' : 'exp'}://login?token=${token}`;
            const fallbackUrl = token === null
                ? `${YP_CONFIG.externe.url}/passwordless_oauth`
                : `${YP_CONFIG.externe.url}/passwordless_oauth?token=${token}`;

            if (isAndroid) {
                if (document.location.href.indexOf('http') === 0) {
                    document.location = appScheme;
                } else {
                    window.location = appScheme;
                }
                setTimeout(() => {
                    window.location = fallbackUrl;
                }, 1000);
            } else if (isiOs) {
                window.location = appScheme;
                setTimeout(() => {
                    window.location = fallbackUrl;
                }, 1000);
            } else {
                window.location = fallbackUrl;
            }
        },
    };
};
window.addEventListener('load', () => {
    if ($('.c-page__exhibit-app-redirect').length > 0) {
        // eslint-disable-next-line no-undef
        YP.ExhibitAppManager().launchExhibitApp();
    }
});
